import React, { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { orderSimulationRoute } from '../route';
import { SearchForm } from './search-form';

const QuantitySearch: FC<{
  soldToId: string;
  shipToId: string;
  productId: string;
}> = ({ soldToId, shipToId, productId }) => {
  const [inputValue, setValue] = useState<string>('');
  const history = useHistory();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.preventDefault();
    setValue(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    history.push(
      orderSimulationRoute(soldToId, {
        shipToId,
        productId,
        quantity: inputValue,
      })
    );
  };

  return (
    <SearchForm
      onSubmit={handleSubmit}
      onChange={handleChange}
      value={inputValue}
    />
  );
};

export { QuantitySearch };
